import { FC, ReactNode } from 'react';
import { useSortable } from '@dnd-kit/sortable';

interface Props {
  id: string;
  disabled?: boolean;
  children: ReactNode | ((params: { isDragging: boolean }) => ReactNode);
}

export const SortableItem: FC<Props> = ({ id, disabled, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  return (
    <li
      ref={setNodeRef}
      style={{
        position: 'relative',
        transform: transform
          ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
          : undefined,
        transition,
        zIndex: isDragging ? 1 : undefined,
        cursor: disabled ? undefined : 'grab',
      }}
      {...attributes}
      {...listeners}
    >
      {typeof children === 'function' ? children({ isDragging }) : children}
    </li>
  );
};
